// primeiro: preferências guardadas antes do nome Hive passam para as chaves atuais
import '@hive/ui/legacy-storage';
import '@hive/ui/styles.css';
import { StrictMode } from 'react';
import { basePath } from '@hive/api';
import { installCspStyleBridge } from '@hive/ui';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { registerServiceWorker } from './lib/pwa';

// política de conteúdo sem estilos inline no build: <style> criado por script vira folha construída
if (import.meta.env.PROD) installCspStyleBridge();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* subcaminho público (HIVE_BASE_PATH, via <base href>): as rotas continuam "/assets", "/network"... */}
    <BrowserRouter basename={basePath() || undefined}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

registerServiceWorker();
